<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined min-height="110vh">
          <v-card-title class="d-flex justify-space-between">
            <div class="text-h5">Link with Pappyon</div>
            <div class="text-body-2 grey--text">
              <v-tooltip bottom close-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" @click="showLWPVideo = true">
                    <v-icon small color="grey lighten-1" class="cursor-pointer"
                      >mdi-help-circle-outline</v-icon
                    >
                    See how it works
                  </div>
                </template>
                <span class="cursor-pointer" @click="showLWPVideo = true"
                  >Watch video</span
                >
              </v-tooltip>
            </div>
          </v-card-title>
          <v-card-text>
            <v-tabs color="primary accent-4" v-model="tab">
              <v-tab
                class="text-capitalize"
                v-for="tabItem in tabItems"
                :key="tabItem.heading"
                >{{ tabItem.header }}</v-tab
              >
              <!-- <v-tab class="text-capitalize">Appearance</v-tab>
              <v-tab class="text-capitalize">Contact & Socials</v-tab>
              <v-tab class="text-capitalize">Links</v-tab> -->
            </v-tabs>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="8">
                <v-tabs-items v-model="tab">
                  <!-- <v-tab-item v-for="(tabItem, index) in tabItems" :key="tabItem.header + index" eager>
                    <component :ref="tabItem.ref" v-bind="{ ...tabItem.props }" :is="tabItem.content"></component>
                  </v-tab-item> -->

                  <v-tab-item eager>
                    <AddEditAppearance />
                  </v-tab-item>
                  <v-tab-item eager>
                    <AddEditContactsAndSocials
                      ref="addEditContactsAndSocials"
                    />
                  </v-tab-item>
                  <v-tab-item eager>
                    <AddEditLinks ref="addEditLinks" />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <!--Start: Fixed column-->
              <v-col cols="4">
                <div class="float-right parent">
                  <v-btn
                    width="150"
                    color="primary"
                    depressed
                    large
                    class="text-body-1 fixed btn"
                    :disabled="isSaveDisabled"
                    @click="handleSave"
                    >Save</v-btn
                  >

                  <v-img
                    src="../assets/highlights.png"
                    width="250"
                    class="image fixed px-3 pt-3 pb-8 mb-5"
                    height="510"
                    ><Preview
                      :linkInBio="transientLinkInBio"
                      height="480"
                      maxHeight="480"
                  /></v-img>
                </div>
              </v-col>
              <!--End: Fixed column-->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <LinkInBioVideo :show="showLWPVideo" @close="showLWPVideo = false" />
  </v-container>
</template>

<script>
import AddEditContactsAndSocials from "@/components/LinkInBio/AddEditContactsAndSocials";
import AddEditLinks from "@/components/LinkInBio/AddEditLinks";
import AddEditAppearance from "@/components/LinkInBio/AddEditAppearance";
import Preview from "@/components/LinkInBio/Preview";
import { mapActions, mapGetters } from "vuex";
import LinkInBio from "@/models/LinkInBio";
import LinkInBioVideo from "@/components/LinkInBio/LinkInBioVideo";

export default {
  components: {
    AddEditContactsAndSocials,
    AddEditLinks,
    AddEditAppearance,
    Preview,
    LinkInBioVideo,
  },

  async created() {
    //Initialize imageURLs array for existing business profiles.
    if (this.businessProfile.imageURLs == undefined)
      this.businessProfile.imageURLs = [];

    //Initialize business name and country from  business profile.
    if (
      this.transientLinkInBio.businessName == "" ||
      this.transientLinkInBio.country == ""
    ) {
      if (this.transientLinkInBio.businessName == "")
        this.transientLinkInBio.businessName =
          this.businessProfile.businessName;

      if (this.transientLinkInBio.country == "")
        this.transientLinkInBio.country = this.businessProfile.country;
      this.transientLinkInBio.save();
    }

    //Tab order
    if (
      this.linkInBio.displayImageURL != "" &&
      this.linkInBio.reverseImageURL != "" &&
      this.transientLinkInBio.backgroundImageURL != ""
    ) {
      this.isEditMode = true;
      this.tab = 2;
    }
  },
  mounted() {
    //Create a deep clone of linkInBio  instead of reference assignment
    let deepCloneLinkInBio = JSON.parse(JSON.stringify(this.linkInBio));
    //let customObj = new LinkInBio(deepCloneLinkInBio);
    let customObj = LinkInBio.fromFireStore(deepCloneLinkInBio);
    this.setTransientLinkInBio(customObj);
  },
  computed: {
    ...mapGetters([
      "linkInBio",
      "selectedBusinessProfileId",
      "businessProfile",
      "transientLinkInBio",
    ]),
    isSaveDisabled() {
      //Compare if transientLinkInBio has been changed
      return (
        JSON.stringify(this.transientLinkInBio) ===
        JSON.stringify(this.linkInBio)
      );
    },
  },
  data() {
    return {
      showLWPVideo: false,
    };
  },
  watch: {
    tab: function (newValue) {
      if (newValue != 2) this.$root.$emit("linkFocused", 0);
    },
  },

  data() {
    return {
      tab: 0,
      isEditMode: false,
      tabItems: [
        {
          header: "Appearance",
          content: "AddEditAppearance",
          ref: "",
          props: { eager: true },
        },
        {
          header: "Contact & Socials",
          content: "AddEditContactsAndSocials",
          ref: "addEditContactsAndSocials",
        },
        {
          header: "Links",
          content: "AddEditLinks",
          ref: "addEditLinks",
          props: { isEditMode: this.isEditMode },
        },
      ],
      showLWPVideo: false,
    };
  },
  methods: {
    ...mapActions(["showSnackbar", "setTransientLinkInBio"]),
    handleSave() {
      let isValid = true;

      for (let i = 0; i < this.tabItems.length; i++) {
        //Check if tab requires validation
        if (this.tabItems[i].ref != "" && this.tabItems[i].ref != undefined) {
          //Check if form in tab is valid
          if (!this.$refs[`${this.tabItems[i].ref}`].validateForm()) {
            this.tab = i;
            isValid = false;
            break;
          }
        }
      }

      //Save
      if (isValid) {
        this.transientLinkInBio.save();
        this.showSnackbar({ show: true, text: "Saved successfully!" });
      }
    },
  },
};
</script>

<style scoped>
.fixed {
  position: fixed;
  /* right: 3%; */
  bottom: 3%;
}

.btn {
  top: 28%;
  right: 6.5%;
}

.image {
  top: 36%;
  right: 3%;
}

.parent {
  position: relative;
}

.false-scroll {
  max-height: 90vh;
}

.v-tooltip__content {
  pointer-events: initial;
}
</style>
